import React, { FunctionComponent } from "react"
import { faqQuestionAnswers } from "../constants/faqSectoin"
import { Accordion } from "./Accordion"

interface FaqSectionProps {}

const FaqSection: FunctionComponent<FaqSectionProps> = () => {
  return (
    <div className="faq-section faq-section-new">
      <div className="faq-content">
        <h2 className="faq-title  h2Text">FAQs</h2>
        {faqQuestionAnswers.map((current, index) => (
          <Accordion
            key={"acc" + index}
            title={current[0]}
            content={current[1]}
            accordionId={`${index}`}
          />
        ))}
      </div>
    </div>
  )
}

export default FaqSection
